/**
 * INFORMES PAGE - Informes y Reportes
 */
import { FileText } from "lucide-react";
import { PlaceholderPage } from "../placeholder-page";

export default function InformesPage() {
  return (
    <PlaceholderPage
      titleKey="informes.title"
      descriptionKey="informes.description"
      icon={FileText}
    />
  );
}
